import React from 'react';

interface ExternalHeaderProps {
    className?: string;
}

const ExternalHeader: React.FC<ExternalHeaderProps> = ({ className = '' }) => {
    return (
        <p className={`text-textGrey font-condensed text-center font-extrabold ${className}`}>
            EXTERNAL LINKS
        </p>
    );
};

export default ExternalHeader;